import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import moment from "moment-timezone";
import CurrencyInput from "react-currency-input";
import ModernDatepicker from "react-modern-datepicker";

import FIELDS from "../../data/fields";
import TimePicker from "../elements/TimePicker";
import MultiSelect from "../multi-select/MultiSelect";
import ClientsAction from "../../app/store/actions/clients";
import {
  createDiscountCoupon,
  updateDiscountCoupon,
} from "../../app/store/actions/discountCoupon";
import { getAllBrands } from "../../app/store/actions/brands";

class DiscountCouponFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponId: null,
      editCoupon: false,
      isLoading: false,
      couponCode: "",
      couponType: 1,
      couponValue: 0,
      minimumValue: 1,
      initialDate: moment().startOf(""),
      finalDate: moment().add(1, "day").startOf(""),
      amountOfUse: 1,
      listClient: [],
      checked: [],
      allClient: false,
      listBrands: [],
      allBrands: false,
      checkedBrands: [],
      description: "",
      messageErro: "",
      messageSuccess: "",
      maximumValue: 1,
      redemptionAmount: false,
      originalAmountOfUse: 0,
    };
  }

  setValue = (att, value) => {
    const { editCoupon, originalAmountOfUse } = this.state;

    if (att === "couponType") {
      this.setState({ couponValue: 0 });
    }

    if (att === "amountOfUse" && !editCoupon) {
      this.setState({ redemptionAmount: value > 1 });
    }

    if (att === "amountOfUse" && editCoupon) {
      if (value < this.state.originalAmountOfUse) {
        return;
      } else if (!value || value === '') {
        this.setState({ [att]: originalAmountOfUse });
      } else {
        this.setState({ [att]: value });
      }
    }

    if (value && value < 0) {
      this.setState({ [att]: Math.abs(value) });
    } else {
      this.setState({ [att]: value });
    }
  };

  handleDate = (date, type) => {
    const currentDate = this.state[type];

    let currenTime = currentDate.format("HH:mm:ss");
    currenTime = `${date} ${currenTime}`;
    const newDate = moment(currenTime, "DD-MM-YYYY HH:mm:ss");

    this.setState({
      [type]: newDate,
    });
  };

  setDateTime = async (date, type) => {
    this.setState({
      [type]: date.clone(),
    });
  };

  selectAllCustomers = async () => {
    await this.setState({
      allClient: true,
      checked: [...[]],
    });
  };

  clearSelectedCustomers = async () => {
    if (this.state.allClient) {
      this.setState({ allClient: false });
    } else {
      this.setState({ checked: [...[]] });
    }
  };

  selectAllBrands = async () => {
    await this.setState({
      allBrands: true,
      checkedBrands: [...[]],
    });
  };

  clearSelectedBrands = async () => {
    if (this.state.allBrands) {
      this.setState({ allBrands: false });
    } else {
      this.setState({ checkedBrands: [...[]] });
    }
  };

  goBack = () => {
    this.props.back.goBack();
  };

  createDiscountCoupon = async () => {
    this.setState({ isLoading: true });
    const {
      couponCode,
      description,
      checked,
      amountOfUse,
      initialDate,
      redemptionAmount,
      finalDate,
      couponType,
      couponValue,
      allClient,
      allBrands,
      checkedBrands,
    } = this.state;

    const value =
      couponType === 1 && couponValue
        ? Number(`${couponValue}`.replace(",", "."))
        : couponValue / 100;
    const minimumValue = Number(`${this.state.minimumValue}`.replace(",", "."));
    const maximumValue = Number(`${this.state.maximumValue}`.replace(",", "."));

    try {
      await this.props.createDiscountCoupon({
        couponCode,
        description,
        checked,
        allClient,
        amountOfUse,
        initialDate,
        finalDate,
        minimumValue,
        couponType,
        value,
        allBrands,
        checkedBrands,
        maximumValue,
        redemptionAmount,
      });

      await this.setState({ messageSuccess: I18n.t("registrationPerformed") });
      await this.goBack();
    } catch (err) {
      const error =
        err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: "" });

      if (error && error.message) {
        const messageError =
          error.code && error.details
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;

        this.setState({ messageErro: messageError });
      } else {
        this.setState({ messageErro: I18n.t("errorOcurred") });
      }
    }
    this.setState({ isLoading: false });
  };

  setSelectedDiscountCoupon = async (selectedDiscountCoupon) => {
    const checked = selectedDiscountCoupon.client.split(",");
    const allClient = checked[0] === "*" ? true : false;
    const checkedBrands = selectedDiscountCoupon.brands.split(",");
    const allBrands = checkedBrands[0] === "*" ? true : false;

    this.setState({
      editCoupon: true,
      couponId: selectedDiscountCoupon.id,
      couponCode: selectedDiscountCoupon.couponCode,
      couponType: selectedDiscountCoupon.type,
      couponValue:
        selectedDiscountCoupon.type === 1
          ? selectedDiscountCoupon.value
          : selectedDiscountCoupon.value * 100,
      minimumValue: selectedDiscountCoupon.minimumValue,
      maximumValue: selectedDiscountCoupon.maximumValue,
      initialDate: moment(selectedDiscountCoupon.initialDate).startOf(""),
      finalDate: moment(selectedDiscountCoupon.finalDate).startOf(""),
      amountOfUse: selectedDiscountCoupon.amountOfUse,
      originalAmountOfUse: selectedDiscountCoupon.amountOfUse,
      redemptionAmount: selectedDiscountCoupon.redemptionAmount,
      checked: !allClient ? checked : [],
      allClient,
      checkedBrands: !allBrands ? checkedBrands : [],
      allBrands,
      description: selectedDiscountCoupon.description,
    });
  };

  updateDiscountCoupon = async () => {
    this.setState({ isLoading: true });
    const {
      couponId,
      description,
      finalDate,
      checked,
      amountOfUse,
      couponType,
      couponValue,
      allClient,
      allBrands,
      checkedBrands,
      redemptionAmount,
    } = this.state;

    const value =
      couponType === 1 && couponValue
        ? Number(`${couponValue}`.replace(",", "."))
        : couponValue / 100;
    const minimumValue = Number(`${this.state.minimumValue}`.replace(",", "."));
    const maximumValue = Number(`${this.state.maximumValue}`.replace(",", "."));

    try {
      await this.props.updateDiscountCoupon({
        couponId,
        description,
        finalDate,
        checked,
        amountOfUse,
        couponType,
        couponValue,
        allClient,
        allBrands,
        checkedBrands,
        value,
        minimumValue,
        maximumValue,
        redemptionAmount,
      });

      await this.setState({ messageSuccess: I18n.t("changeMade") });
      await this.goBack();
    } catch (err) {
      const error =
        err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: "" });

      if (error && error.message) {
        const messageError =
          error.code && error.details
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;

        this.setState({ messageErro: messageError });
      } else {
        this.setState({ messageErro: I18n.t("errorOcurred") });
      }
    }
    this.setState({ isLoading: false });
  };

  componentDidMount = async () => {
    const listClient = await this.props.getAllClients();
    const listBrands = await this.props.getAllBrands();
    await this.setState({
      listClient: [...listClient],
      listBrands: [...listBrands],
    });

    if (this.props.back.location.selectedDiscountCoupon) {
      await this.setSelectedDiscountCoupon(
        this.props.back.location.selectedDiscountCoupon
      );
    }
  };

  handleSelectClients = async (selected) => {
    this.setState({ checked: selected });
  };

  handleSelectBrands = async (selected) => {
    this.setState({ checkedBrands: selected });
  };

  render() {
    const {
      couponCode,
      couponType,
      couponValue,
      minimumValue,
      isLoading,
      messageSuccess,
      listBrands,
      initialDate,
      finalDate,
      amountOfUse,
      listClient,
      description,
      messageErro,
      editCoupon,
      maximumValue,
      redemptionAmount,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">{I18n.t("couponRegistration")}</h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("couponCode")}</p>
            <input
              type="text"
              onChange={(e) =>
                this.setValue(
                  "couponCode",
                  `${e.target.value}`
                    .toLocaleUpperCase()
                    .replace(/[^A-Z0-9_]+/g, "")
                )
              }
              value={couponCode}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
              disabled={editCoupon}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("description")}</p>
            <input
              type="text"
              onChange={(e) => this.setValue("description", e.target.value)}
              value={description}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div>
            <div
              className="row margin-left-0 margin-top-10"
              style={{ marginBottom: "5px" }}
            >
              <button
                type="button"
                style={{ height: "1%" }}
                onClick={this.clearSelectedCustomers}
                className="btn btn-dark btn-sm margin-right-15"
              >
                {I18n.t("clean")}
              </button>

              <button
                type="button"
                style={{ height: "1%" }}
                className="btn btn-dark btn-sm"
                onClick={this.selectAllCustomers}
              >
                {I18n.t("allCustomers")}
              </button>
            </div>
            <div className="form-group">
              <p
                style={
                  !this.state.allClient && !!listClient.length
                    ? { marginBottom: "0px" }
                    : {}
                }
                className={this.state.allClient ? "margin-bottom-2" : ""}
              >
                {I18n.t("clients")}
              </p>
              {!this.state.allClient && !!listClient.length ? (
                <MultiSelect
                  options={listClient}
                  checked={this.state.checked}
                  onSelectOptions={this.handleSelectClients}
                  className="form-control multiSelect-input"
                />
              ) : (
                <input
                  type="text"
                  value={I18n.t("allSelectedCustomer")}
                  disabled={true}
                  className="form-control"
                  placeholder=""
                />
              )}
            </div>
          </div>

          <div>
            <div
              className="row margin-left-0 margin-top-10"
              style={{ marginBottom: "5px" }}
            >
              <button
                type="button"
                style={{ height: "1%" }}
                onClick={this.clearSelectedBrands}
                className="btn btn-dark btn-sm margin-right-15"
              >
                {I18n.t("clean")}
              </button>

              <button
                type="button"
                style={{ height: "1%" }}
                className="btn btn-dark btn-sm"
                onClick={this.selectAllBrands}
              >
                {I18n.t("allBrands")}
              </button>
            </div>
            <div className="form-group">
              <p
                style={
                  !this.state.allBrands && !!listBrands.length
                    ? { marginBottom: "0px" }
                    : {}
                }
                className={this.state.allBrands ? "margin-bottom-2" : ""}
              >
                {I18n.t("brands")}
              </p>
              {!this.state.allBrands && !!listBrands.length ? (
                <MultiSelect
                  options={listBrands}
                  checked={this.state.checkedBrands}
                  onSelectOptions={this.handleSelectBrands}
                  className="form-control multiSelect-input"
                />
              ) : (
                <input
                  value={I18n.t("allBrandsSelected")}
                  className="form-control"
                  type="text"
                  disabled
                />
              )}
            </div>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("amountOfUse")}</p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "0.75rem",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                type="Number"
                value={amountOfUse}
                className="form-control"
                onChange={(e) =>
                  this.setValue(
                    "amountOfUse",
                    e.target.value === ""
                      ? ""
                      : Number(e.target.value)
                      ? parseInt(e.target.value)
                      : 1
                  )
                }
              />

              <div className="form-check">
                <input
                  checked={redemptionAmount}
                  type="checkbox"
                  className="form-check-input checkbox-permissions"
                  onChange={(e) =>
                    this.setValue("redemptionAmount", !redemptionAmount)
                  }
                  disabled={editCoupon}
                />
                <p className="permission-text" style={{ textAlign: "center" }}>
                  {I18n.t("redemptionAmount")}
                </p>
              </div>
            </div>
          </div>

          <div className="form-group form-promotion-picker">
            <p className="margin-bottom-2">{I18n.t("couponStartDate")}</p>
            <div className="inputs">
              {!editCoupon ? (
                <ModernDatepicker
                  date={initialDate}
                  format="DD-MM-YYYY"
                  showBorder
                  onChange={(date) => this.handleDate(date, "initialDate")}
                  placeholder=""
                  className="form-control"
                />
              ) : (
                <input
                  type="text"
                  value={moment(initialDate).format("DD-MM-YYYY")}
                  className="form-control kGGIis"
                  disabled={true}
                />
              )}
              <TimePicker
                date={initialDate}
                setDateTime={(date) => this.setDateTime(date, "initialDate")}
                disabled={editCoupon}
              />
            </div>
          </div>

          <div className="form-group form-promotion-picker">
            <p className="margin-bottom-2">{I18n.t("couponEndDate")}</p>
            <div className="inputs">
              <ModernDatepicker
                date={finalDate}
                format="DD-MM-YYYY"
                showBorder
                onChange={(date) => this.handleDate(date, "finalDate")}
                placeholder=""
                className="form-control"
              />
              <TimePicker
                date={finalDate}
                setDateTime={(date) => this.setDateTime(date, "finalDate")}
              />
            </div>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("minimumValue")}</p>
            <CurrencyInput
              decimalSeparator=","
              thousandSeparator=""
              value={minimumValue}
              className="form-control"
              onChangeEvent={(e) =>
                this.setValue("minimumValue", e.target.value)
              }
              maxLength={FIELDS.float_max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("maximumValue")}</p>
            <CurrencyInput
              decimalSeparator=","
              thousandSeparator=""
              value={maximumValue}
              className="form-control"
              onChangeEvent={(e) =>
                this.setValue("maximumValue", e.target.value)
              }
              maxLength={FIELDS.float_max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t("couponType")}</p>
            <select
              onChange={(e) =>
                this.setValue("couponType", parseInt(e.target.value))
              }
              className="custom-select"
              value={couponType}
            >
              <option key={1} value={1}>
                {I18n.t("value")}
              </option>
              <option key={2} value={2}>
                {I18n.t("percentage")}
              </option>
            </select>
          </div>

          {couponType === 1 ? (
            <div className="form-group">
              <p className="margin-bottom-2">{I18n.t("value")}</p>
              <CurrencyInput
                decimalSeparator=","
                thousandSeparator=""
                value={couponValue}
                className="form-control"
                onChangeEvent={(e) =>
                  this.setValue("couponValue", e.target.value)
                }
                maxLength={FIELDS.float_max}
              />
            </div>
          ) : (
            <div className="form-group">
              <p className="margin-bottom-2">{I18n.t("percentage")}</p>
              <input
                type="text"
                value={couponValue}
                className="form-control"
                onChange={(e) =>
                  this.setValue("couponValue", Number(e.target.value) || 0)
                }
                maxLength={FIELDS.percentage}
              />
            </div>
          )}

          {!!messageSuccess && (
            <p className="color-green margin-top-10">{messageSuccess}</p>
          )}
          {!!messageErro && (
            <p className="color-red margin-top-10">{messageErro}</p>
          )}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t("return")}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() =>
                !editCoupon
                  ? this.createDiscountCoupon()
                  : this.updateDiscountCoupon()
              }
              disabled={isLoading}
            >
              {!editCoupon ? I18n.t("save") : I18n.t("update")}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getAllClients: () => dispatch(ClientsAction.getAllClients()),
  getAllBrands: () => dispatch(getAllBrands()),
  createDiscountCoupon: (newDiscountCoupon) =>
    dispatch(createDiscountCoupon(newDiscountCoupon)),
  updateDiscountCoupon: (discountCouponParameter) =>
    dispatch(updateDiscountCoupon(discountCouponParameter)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscountCouponFormComponent);
